export default {"src":"/_next/static/media/calendarTooth_24.7d1de48f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};